<template lang="pug">
    div
        .abacus
            .abacus__plank-container
                .abacus__plank.abacus__plank--large
            .abacus__bones-block
                .abacus__digit-block(v-for='(digit, index) in digitsArray')
                    .abacus__rod
                    .abacus__bone.abacus__bone--bottom(v-if='digit >= 5', @click='changeNumberOnFive(digit, index)')
                    .abacus__bone.abacus__bone--top(v-else='', @click='changeNumberOnFive(digit, index)')
            .abacus__plank-container
                .abacus__plank
            .abacus__bones-block
                .abacus__digit-block(v-for='(digit, index1) in digitsArray')
                    .abacus__rod
                    .abacus__bone.abacus__bone-top(
                        v-for='(n, index2) in digit%5',
                        @click='subtractNumber(digit, index1, index2)'
                    )
                    .abacus__bone.abacus__bone--bottom(
                        v-for='(n, index2) in 4 - digit%5',
                        @click='appendNumber(digit, index1, index2)'
                    )
            .abacus__plank-container
                .abacus__plank.abacus__plank--large
            a.abacus__refresh-link(@click="$emit('resetAbacusNumber')") {{ $i18n.t('trainer.trainer_gamePlayBox_resetToZero') }}
</template>

<script>
    import { flatten } from 'lodash';

    export default {
        props: {
            number: {
                type: Number,
                default: 0,
            },
            gameDifficult: {
                type: [String, Number],
                default: '',
            },
            digitCapacity: {
                type: Object,
                default: () => ({}),
            },
            fractions: {
                default: () => ({}),
            },
            fractionalPart: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                currentIndex: 0,
                numbersArray: [],
            };
        },
        methods: {
            changeNumberOnFive(number, index) {
                number >= 5 ? (number -= 5) : (number += 5);
                this.emitNumber(number, index);
            },
            subtractNumber(number, index1, index2) {
                let countOfSpokes = number % 5;
                if (countOfSpokes === 1 && index2 === 0) {
                    number -= 1;
                } else if (countOfSpokes === 2) {
                    index2 === 0 ? (number -= 2) : (number -= 1);
                } else if (countOfSpokes === 3) {
                    if (index2 === 0) number -= 3;
                    if (index2 === 1) number -= 2;
                    if (index2 === 2) number -= 1;
                } else if (countOfSpokes === 4) {
                    if (index2 === 0) number -= 4;
                    if (index2 === 1) number -= 3;
                    if (index2 === 2) number -= 2;
                    if (index2 === 3) number -= 1;
                }
                this.emitNumber(number, index1);
            },
            appendNumber(number, index1, index2) {
                let countOfSpokes = 4 - (number % 5);
                if (countOfSpokes === 1 && index2 === 0) {
                    number += 1;
                } else if (countOfSpokes === 2) {
                    index2 === 1 ? (number += 2) : (number += 1);
                } else if (countOfSpokes === 3) {
                    if (index2 === 2) number += 3;
                    if (index2 === 1) number += 2;
                    if (index2 === 0) number += 1;
                } else if (countOfSpokes === 4) {
                    if (index2 === 3) number += 4;
                    if (index2 === 2) number += 3;
                    if (index2 === 1) number += 2;
                    if (index2 === 0) number += 1;
                }
                this.emitNumber(number, index1);
            },
            emitNumber(number, index) {
                this.numbersArray[index] = number;
                let stringOfNumber = '';
                this.numbersArray.forEach(val => {
                    stringOfNumber += val;
                });
                this.$emit('number', Number(stringOfNumber));
            },
        },
        watch: {
            digitsArray(array) {
                this.numbersArray = array;
            },
        },
        computed: {
            digitsArray() {
                let array = String(this.number)
                    .split('')
                    .map(Number);
                while (array.length < this.countOfSpokes) {
                    array.unshift(0);
                }
                while (array.length > this.countOfSpokes) {
                    array.shift();
                }
                return array;
            },
            countOfSpokes() {
                if (this.rootsAndDegrees) {
                    if (this.gameDifficult === 'Однозначные цифры' || this.gameDifficult === 1) {
                        if (this.fractions) {
                            return 4;
                        }
                        return 2;
                    }
                    if (this.gameDifficult === 'Двузначные цифры' || this.gameDifficult === 2) {
                        if (this.fractions) {
                            return 6;
                        }
                        return 4;
                    }
                    if (
                        this.gameDifficult === 'Шестизначные цифры' ||
                        this.gameDifficult === 6 ||
                        this.gameDifficult === 'Семизначные цифры' ||
                        this.gameDifficult === 7 ||
                        this.gameDifficult === 'Восьмизначные цифры' ||
                        this.gameDifficult === 8
                    ) {
                        return 8;
                    }
                }
                if (this.isMultiplicationAndDivision) {
                    if (this.gameDifficult === 'Однозначные цифры' || this.gameDifficult === 1) {
                        if (this.fractions.left || this.fractions.right) {
                            return 4;
                        }
                        return 2;
                    }
                    if (this.gameDifficult === 'Двузначные цифры' || this.gameDifficult === 2) {
                        if (this.fractions.left || this.fractions.right) {
                            return 6;
                        }
                        return 4;
                    }
                    if (
                        this.gameDifficult === 'Шестизначные цифры' ||
                        this.gameDifficult === 6 ||
                        this.gameDifficult === 'Семизначные цифры' ||
                        this.gameDifficult === 7 ||
                        this.gameDifficult === 'Восьмизначные цифры' ||
                        this.gameDifficult === 8
                    ) {
                        return 8;
                    }
                    const digitCapacities = flatten(Object.values(this.digitCapacity));
                    if (
                        (digitCapacities[0] === 2 && digitCapacities[1] === 3) ||
                        (digitCapacities[0] === 3 && digitCapacities[1] === 2)
                    ) {
                        return 6;
                    }
                }
                if (this.isExpressions) {
                    switch (this.gameDifficult) {
                        case 1:
                        case 'Однозначные цифры':
                            return 3;
                        case 2:
                        case 'Двузначные цифры':
                            return 4;
                        case 3:
                        case 'Трехзначные цифры':
                            return 5;
                        case 4:
                        case 'Четырехзначные цифры':
                            return 6;
                        case 5:
                        case 'Пятизначные цифры':
                        case 6:
                        case 'Шестизначные цифры':
                        case 7:
                        case 'Семизначные цифры':
                        case 8:
                        case 'Восьмизначные цифры':
                            return 8;
                    }
                }
                let countOfSpokes;
                switch (this.gameDifficult) {
                    case 1:
                    case 'Однозначные цифры':
                        countOfSpokes = 2;
                        break;
                    case 2:
                    case 'Двузначные цифры':
                        countOfSpokes = 3;
                        break;
                    case 3:
                    case 'Трехзначные цифры':
                        countOfSpokes = 4;
                        break;
                    case 4:
                    case 'Четырехзначные цифры':
                        countOfSpokes = 5;
                        break;
                    case 5:
                    case 'Пятизначные цифры':
                        countOfSpokes = 6;
                        break;
                    case 6:
                    case 'Шестизначные цифры':
                        countOfSpokes = 7;
                        break;
                    case 7:
                    case 'Семизначные цифры':
                    case 8:
                    case 'Восьмизначные цифры':
                        countOfSpokes = 8;
                        break;
                    default:
                        countOfSpokes = 1;
                }
                countOfSpokes += this.fractions ? this.fractionalPart : 0;
                return countOfSpokes <= 8 ? countOfSpokes : 8;
            },
            rootsAndDegrees() {
                return this.$route.name.includes('roots-and-degrees');
            },
            isMultiplicationAndDivision() {
                return this.$route.name.includes('multiplication-and-division');
            },
            isAddAndSub() {
                return this.$route.name.includes('addition-and-subtraction') || this.$route.name.includes('anzan');
            },
            isExpressions() {
                return this.$route.name.includes('expressions');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .abacus {
        display: flex;
        flex-direction: column;
        &__plank-container {
            display: flex;
            justify-content: center;
        }
        &__plank {
            width: 100%;
            height: 17px;
            border-radius: 5px;
            $color-burgundy: #8b4220;
            $color-copper: #b87333;
            background: linear-gradient($color-copper, $color-burgundy);
            @media screen and (max-width: 575px) {
                height: 14px;
            }
            @include base-shadow;
            &--large {
                height: 25px;
                @media screen and (max-width: 991px) {
                    height: 16px;
                }
                @media screen and (max-width: 575px) {
                    height: 13px;
                }
                @media screen and (max-width: 359px) {
                    height: 10px;
                }
            }
        }
        &__bones-block {
            display: flex;
            flex-direction: row;
        }
        &__digit-block {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 45px;
            margin: 0 $space-large;
            @media screen and (max-device-width: 1438px) {
                width: 35px;
                margin: 0 11px;
            }
            @media screen and (max-device-width: 991px) {
                width: 14px;
                margin: 0 11px;
            }
            @media screen and (max-device-width: 767px) {
                width: 20px;
                margin: 0 $space-x-small;
            }
            @media screen and (max-device-width: 575px) {
                width: 20px;
                margin: 0 $space-xx-small;
            }
            @media screen and (max-device-width: 359px) {
                width: 13px;
                margin: 0 $space-xx-small;
            }
        }
        &__bone {
            border-radius: 25px;
            box-shadow: inset 0 0 10px 1px rgba(0, 0, 0, 0.2), inset -3px 0 3px rgba(255, 255, 255, 0.3);
            background: linear-gradient(to top, #4a7928, #76a554);
            height: 45px;
            width: 85px;
            @media screen and (max-device-width: 1438px) {
                height: 30px;
                width: 50px;
            }
            @media screen and (max-device-width: 991px) {
                height: 22px;
                width: 36px;
            }
            @media screen and (max-device-width: 767px) {
                height: 22px;
                width: 30px;
            }
            @media screen and (max-device-width: 575px) {
                height: 20px;
                width: 30px;
            }
            @media screen and (max-device-width: 359px) {
                height: 15px;
                width: 20px;
            }
            &--top {
                order: 1;
            }
            &--bottom {
                order: 3;
            }
        }
        &__rod {
            height: 30px;
            width: 20px;
            order: 2;
            background: linear-gradient(to right, #8b4220, #b5743a);
            @media screen and (max-width: 991px) {
                height: 20px;
            }
            @media screen and (max-device-width: 450px) {
                width: 15px;
            }
            @media screen and (max-width: 359px) {
                height: 16px;
                width: 10px;
            }
        }
    }
    .abacus__refresh-link {
        text-align: center;
        cursor: pointer;
        margin-top: 10px;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
        @media screen and (max-width: 575px) {
            margin: 0;
        }
    }
    .multi-screen {
        .abacus {
            &__digit-block {
                @media screen and (min-device-width: 1000px) {
                    width: 38px;
                    margin: 0 calc(#{$space-x-small} / 2);
                }
                @include media($xlg) {
                    width: 50px;
                    margin: 0 $space-x-small;
                }
            }
            &__bone {
                @media screen and (min-device-width: 1000px) {
                    height: 30px;
                    width: 38px;
                }
                @include media($xlg) {
                    height: 35px;
                    width: 50px;
                }
                @media screen and (max-width: 991px) {
                    height: 22px;
                    width: 45px;
                }
            }
            &__rod {
                @media screen and (min-device-width: 1000px) {
                    width: 15px;
                }
                @include media($xlg) {
                    width: 20px;
                }
            }
        }
    }
</style>
